import React from "react";
import {
  Edit,
  SimpleForm,
  FormDataConsumer,
  ReferenceField,
  TextField,
  TextInput,
  SelectInput,
  TopToolbar,
  RefreshButton,
  ListButton,
  ShowButton,
  DateInput,
} from "react-admin";
import { CamelCaseField } from "./common";
import { LineItemsSideComponent } from "../singleDeliveryOrders/common";
import { getDigitalOrderStatusChoices } from "../common/common";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const EditActions = ({ basePath, data }) => (
  <TopToolbar>
    <RefreshButton />
    <ListButton basePath={basePath} />
    <ShowButton basePath={basePath} record={data} />
  </TopToolbar>
);

const DigitalOrdersEdit = ({ permissions, ...props }) => {
  return (
    <Edit
      className="digital-order-edit"
      title="Digital Order Edit"
      aside={<LineItemsSideComponent />}
      actions={<EditActions permissions={permissions} />}
      undoable={false}
      {...props}
    >
      <SimpleForm>
        <ReferenceField
          label="Sold To Name"
          source="business_id"
          reference="businesses"
          link="show"
          allowEmpty
        >
          <TextField source="name" />
        </ReferenceField>
        <TextInput source="order_number" />
        <CamelCaseField
          source="mode_of_delivery"
          label="Mode Of Delivery"
          addLabel
        />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.customer_order_status == 0 && (
              <DateInput
                source="delivery_date_from"
                label={
                  formData.mode_of_delivery == "agency" ||
                  formData.mode_of_delivery == "delivered"
                    ? "Dispatch Date"
                    : "Pickup Date"
                }
                options={{ format: "d/M/y", ampm: true }}
              />
            )
          }
        </FormDataConsumer>
        <SelectInput
          source="customer_order_status"
          choices={getDigitalOrderStatusChoices()}
        />
        <FormDataConsumer>
          {({ formData, ...rest }) =>
            formData.customer_order_status === 4 && (
              <TextInput
                multiline
                source="sap_order_failed_message"
                label="Message"
                {...rest}
              />
            )
          }
        </FormDataConsumer>
      </SimpleForm>
    </Edit>
  );
};

export default DigitalOrdersEdit;
